import React, { useState, useRef, useEffect } from 'react';
import { aiAPI } from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'react-toastify';
import { format } from 'date-fns';

const CHIPS = [
  { icon:'📢', label:'كتابة تعميم',    prompt:'اكتب تعميماً إدارياً رسمياً' },
  { icon:'📊', label:'تلخيص اجتماع',  prompt:'لخّص محاضر الاجتماع التالي' },
  { icon:'🖊', label:'قرار إداري',     prompt:'اكتب قراراً إدارياً رسمياً' },
  { icon:'📈', label:'تحليل إحصاءات', prompt:'حلّل إحصائيات التواصل الشهرية' },
  { icon:'🔍', label:'بحث ذكي',        prompt:'ابحث في الوثائق الإدارية عن' },
  { icon:'🌐', label:'ترجمة',          prompt:'ترجم النص التالي للإنجليزية بأسلوب رسمي:' },
  { icon:'✍️', label:'خطاب رسمي',     prompt:'اكتب خطاباً رسمياً لـ' },
  { icon:'📋', label:'تقرير تشغيلي',  prompt:'أنشئ تقريراً تشغيلياً شاملاً عن' },
];

export default function AIAssistant() {
  const { user }      = useAuth();
  const [messages, setMessages] = useState([
    { role:'assistant', content:'مرحباً! أنا مساعد SPORTIX-MATRIX الذكي.\nأستطيع مساعدتك في:\n• كتابة وصياغة التعاميم والقرارات\n• تلخيص محاضر الاجتماعات\n• تحليل إحصائيات التواصل\n• الترجمة والخطابات الرسمية\n• البحث الذكي في الوثائق\n\nاكتب طلبك أو اختر أحد الاقتراحات أعلاه 👆' }
  ]);
  const [input, setInput]       = useState('');
  const [convId, setConvId]     = useState(null);
  const [loading, setLoading]   = useState(false);
  const [convs, setConvs]       = useState([]);
  const msgsEnd = useRef(null);

  useEffect(() => {
    aiAPI.conversations().then(r => setConvs(r.data)).catch(()=>{});
  }, []);

  useEffect(() => {
    msgsEnd.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const send = async (text) => {
    const q = text || input;
    if (!q.trim()) return;
    setInput('');
    setMessages(prev => [...prev, { role:'user', content:q }]);
    setLoading(true);
    const thinking = { role:'assistant', content:'⏳ جارٍ المعالجة...', loading:true };
    setMessages(prev => [...prev, thinking]);
    try {
      const { data } = await aiAPI.chat({ conversation_id: convId, message: q });
      setConvId(data.conversation_id);
      setMessages(prev => [...prev.filter(m=>!m.loading), { role:'assistant', content:data.reply }]);
      if (!convId) aiAPI.conversations().then(r=>setConvs(r.data)).catch(()=>{});
    } catch (err) {
      setMessages(prev => [...prev.filter(m=>!m.loading), { role:'assistant', content:'⚠ ' + (err.response?.data?.message||'حدث خطأ') }]);
    } finally { setLoading(false); }
  };

  const loadConv = async (id) => {
    try {
      const { data } = await aiAPI.history(id);
      setMessages(data.map(m => ({ role:m.role, content:m.content })));
      setConvId(id);
    } catch { toast.error('فشل تحميل المحادثة'); }
  };

  return (
    <div className="fade-in">
      <div className="ai-banner">
        <div style={{display:'flex',alignItems:'center',gap:9,marginBottom:10}}>
          <span style={{fontSize:22}}>🤖</span>
          <div style={{flex:1}}>
            <div style={{fontSize:13,fontWeight:800}}>مساعد الذكاء الاصطناعي</div>
            <div style={{fontSize:9,opacity:.6}}>متخصص في التواصل والإدارة الرياضية · Claude Sonnet</div>
          </div>
          <span style={{background:'var(--gd)',color:'var(--nv)',fontSize:8,fontWeight:800,padding:'2px 7px',borderRadius:8}}>Claude AI</span>
        </div>
        <div>
          {CHIPS.map(c => (
            <span key={c.label} className="ai-chip" onClick={() => setInput(c.prompt + ' ')}>
              {c.icon} {c.label}
            </span>
          ))}
        </div>
      </div>

      <div className="g2">
        {/* Conversations list */}
        <div style={{maxWidth:220,minWidth:180}}>
          <div className="card">
            <div className="card-header"><div className="card-icon" style={{background:'var(--inb)'}}>🗂</div><div className="card-title">المحادثات</div></div>
            <div className="card-body" style={{padding:'8px 10px'}}>
              <button className="btn btn-primary" style={{width:'100%',justifyContent:'center',marginBottom:8}} onClick={()=>{setMessages([]);setConvId(null);}}>+ محادثة جديدة</button>
              {convs.map(c => (
                <div key={c.id} style={{padding:'7px 9px',borderRadius:8,cursor:'pointer',fontSize:10,fontWeight:c.id===convId?700:400,background:c.id===convId?'var(--inb)':'transparent',marginBottom:3}} onClick={()=>loadConv(c.id)}>
                  💬 {c.title}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Chat */}
        <div className="card" style={{flex:1}}>
          <div className="ai-messages" style={{minHeight:300,maxHeight:420}}>
            {messages.map((m,i) => (
              <div key={i} style={{display:'flex',gap:8,maxWidth:'80%',alignSelf:m.role==='user'?'flex-end':'flex-start',flexDirection:m.role==='user'?'row-reverse':'row'}}>
                <div className="avatar" style={{width:28,height:28,borderRadius:'50%',background:m.role==='user'?user?.avatar_color||'var(--gd)':'var(--nv)',color:'#fff',fontSize:m.role==='user'?9:13,flexShrink:0}}>
                  {m.role==='user'?user?.initials:'🤖'}
                </div>
                <div className="message-bubble" style={{background:m.role==='user'?'var(--nv)':'var(--wh)',color:m.role==='user'?'#fff':'var(--t1)',border:m.role==='user'?'none':'1px solid var(--b1)',borderRadius:m.role==='user'?'12px 12px 2px 12px':'12px 12px 12px 2px',opacity:m.loading?.9:1,whiteSpace:'pre-wrap'}}>
                  {m.content}
                </div>
              </div>
            ))}
            <div ref={msgsEnd}/>
          </div>
          <div className="card-body" style={{borderTop:'1px solid var(--b1)'}}>
            <div className="ai-input-row">
              <textarea className="ai-textarea" value={input} onChange={e=>setInput(e.target.value)}
                placeholder="اكتب طلبك... مثال: اكتب تعميماً عن تأجيل الاجتماع"
                onKeyDown={e=>{ if(e.key==='Enter'&&!e.shiftKey){e.preventDefault();send();}}}
              />
              <button className="btn btn-primary" onClick={()=>send()} disabled={loading} style={{alignSelf:'flex-end',whiteSpace:'nowrap'}}>
                {loading?'⏳':'إرسال 🚀'}
              </button>
            </div>
            <div style={{fontSize:8.5,color:'var(--t3)',marginTop:6}}>💡 توليد ردود بواسطة Claude AI · باللغة العربية</div>
          </div>
        </div>
      </div>
    </div>
  );
}
